export namespace NotificationTypeId {
  export const Coupon = 1n;
  export const Deposit = 2n;
  export const Withdrawal = 3n;
  export const KYC = 4n;
  export const Comission = 5n; // bonus
  export const BonusWithdrawal = 6n;
  export const Follow = 7n;
  export const Bet = 8n; // copy bet
  export const Tournament = 9n;
  export const GameBet = 11n;
  export const Alert = 12n;
  export const Reward = 10n;
}

export type NotificationTypeIdType =
  (typeof NotificationTypeId)[keyof typeof NotificationTypeId];
